import { config } from "@src/config";
import dayjs from "dayjs";

type ValueType = "array" | "timeRange" | "default";

export function isValueChanged(initialValue: any, currentValue: any, type: ValueType = "default"): boolean {
  switch (type) {
    case "array":
      return JSON.stringify(initialValue ?? []) !== JSON.stringify(currentValue ?? []);
    case "timeRange": {
      if (!Array.isArray(initialValue) || !Array.isArray(currentValue)) return true;
      const [initStart, initEnd] = initialValue.map((d: any) => dayjs(d).format(config.DATE_FORMAT));
      const [currStart, currEnd] = currentValue.map((d: any) => dayjs(d).format(config.DATE_FORMAT));
      return initStart !== currStart || initEnd !== currEnd;
    }

    default:
      return initialValue !== currentValue;
  }
}
